<template>
    <div style="margin-top: -10px; ">
        <!-- <div class="row">
        <div class="col-12" style="margin-top: -10px; ">
            <div style="height: 30px; line-height: 30px; padding-bottom: 32px; border-bottom: 2px #CBCBCB solid; margin-bottom: 20px" > <p style="font-size:15px; font-family: inherit; font-weight: 500; text-align: center; color: #015A6C; text-transform: uppercase;"> {{buildingName}}</p>
            </div>
        </div>
    </div> -->
        <div class="row">
            <div class="col-8">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style="font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center">{{buildingName}} / Providers</span>
                </div>
            </div>
            <div class="col-4 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <span style="
width: 30px;
height: 30px;
border-radius: 5px;
            background-color: #007DFC;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            margin-right:8px;
          ">
                        <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                    </span>

                    <span @click="showSearch()"
                          style="
                          width: 30px;
                          height: 30px;
                          border-radius: 5px;
                          background-color: #007DFC;
                          color: white;
                          display: inline-block;
                          padding-left: 5px;
                          padding-right: 5px;
                          text-align: center;
                          cursor:pointer;

                          ">
                        <i class="fa fa-search" style="margin-top:7px;" aria-hidden="true"></i>
                    </span>
                    <input type="text" v-if="visibleSearch" class="form-control" name="searchText" id="searchText" style=" display: inline-block; width: 250px; height: 30px;" v-model="filter">
                    <userMenu />
                </div>
            </div>
        </div>

        <div class="row">
           
            <div class="offset-md-9 col-3 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <span style="margin-right:5px">Add New Provider</span>
                    <router-link class="btn btn-table" :to="{ name: 'supplier',params:{buildingId:buildingId, buildingName:buildingName} }"><i class="fas fa-plus"></i></router-link>
                </div>
            </div>
        </div>

        <div v-if="false" class="row">
            <div class="pull-left col-lg-3 col-md-3 col-sm-5 col-12" style="padding-left:0;margin-bottom:10px;display:inline-flex">
                <div class="size" style="margin-left:15px">
                    Show
                    <select class="size-select" v-model="size">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                    </select>
                    Entries
                </div>
            </div>

            <div class="sortBy col-lg-3 col-md-3 col-sm-5 col-12" style="margin-bottom:22px">
                Sort By
                <select class="sortBy-select" v-model="sortBy">
                    <option value="Name">Name</option>
                    <option value="Service">Service</option>
                </select>
            </div>

            <div class="search col-lg-3 col-md-3 col-sm-4 col-6 marginLeftSmallScreen" style="min-width:180px; margin-top:12px">
                <span class="fa fa-search"></span>
                <input type="text" class="form-control" name="searchText" id="searchText" placeholder="Search Supplier..." v-model="filter">
            </div>

            <div class="col-lg-3 col-md-3 col-sm-4 col-6 pull-right" style="text-align:right">
                <router-link class="btn btn-primary" :to="{name:'supplier', params:{buildingId:buildingId, buildingName:buildingName}}">Add Supplier</router-link>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <th scope="col" style="width:14%">No</th>
                        <th scope="col" style="width:14%">Supplier</th>
                        <th scope="col" style="width:14%">Service Type</th>
                        <th scope="col" style="width:14%">Contact Name</th>
                        <th scope="col" style="width:14%">Contact Surname</th>
                        <th scope="col" style="width:14%">Email</th>
                        <th scope="col" style="width:14%">Phone Number</th>
                        <th scope="col" style="width:14%">Fax</th>
                        <th scope="col" style="width:14%">Website</th>
                        <th scope="col" style="width:2%"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="supplier, key in paginatedData" class="clickable-row">
                        <td scope="row" class="clickable-column"><a @click.prevent="editItem(supplier)">{{ ++key }}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(supplier)">{{ supplier.name}}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(supplier)">{{ supplier.serviceTypesString}}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(supplier)">{{ supplier.firstName}}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(supplier)">{{ supplier.surname}}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(supplier)">{{ supplier.email}}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(supplier)">{{ supplier.phoneNumber}}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(supplier)">{{ supplier.fax}}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(supplier)">{{ supplier.website}}</a></td>
                        <td style="width:11.5%">
                            <a class="btn btn-table" @click.prevent="deleteItem(supplier)"><i class="fas fa-times"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- MODAL IS HERE -->
        <modal :scrollable="true" name="deleteAlert" @before-open="beforeOpen" height="auto" :minHeight="150" width="400">
            <div class="" role="document">
                <div class="">
                    <!-- Modal content-->
                    <deleteAlert v-on:close="modalClosed" :entity-id="selectedItemId" request="suppliers" entity="supplier" />
                </div>
            </div>
        </modal>
        <div class="row">
            <div class="col-8 table-summary">
                <span>  Showing {{startEntry}} to {{endEntry}} of {{numberOfEntries}} entries </span>
            </div>
            <div class="col-4">
                <paginate :page-count="numberOfPages"
                          :page-range="3"
                          :margin-pages="2"
                          :click-handler="clickCallback"
                          :prev-text="'<'"
                          :next-text="'>'"
                          :container-class="'pagination'"
                          :page-class="'page-item'">
                </paginate>
            </div>
        </div>
    </div>
</template>
<style scoped>
@media (max-width: 959px) {
  .marginLeftSmallScreen {
    margin-left: 13px !important;
    margin-right: -13px !important;
  }
}
</style>
<script>
import { mapState } from "vuex";
export default {
  data: function () {
    return {
      size: 10,
      sortBy: "Name",
      filter: "",
      pageNumber: 0,
      suppliers: [],
      buildingId: 0,
     // buildingName: "",
      selectedItemId: 0,
      visibleSearch: false,
    };
  },
  mounted() {
    this.buildingId = this.$route.params.buildingId;
  //  this.buildingName = this.$route.params.buildingName;
    //this.buildingName = this.$route.params.buildingName;
    this.fetchStatement();
  },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    getSuppliers() {
      var suppliers = this.suppliers.filter((supplier) => {
        return supplier.name.toLowerCase().includes(this.filter.toLowerCase());
      });

      return suppliers;
    },
    numberOfEntries() {
      return this.getSuppliers.length;
    },
    numberOfPages() {
      let l = this.numberOfEntries,
        s = this.size;
      return Math.ceil(l / s);
    },
    startEntry() {
      if (this.numberOfEntries == 0) {
        return 0;
      }
      if (this.pageNumber + 1 == 1) {
        return 1;
      } else {
        return this.pageNumber * this.size + 1;
      }
    },
    endEntry() {
      if (this.numberOfEntries <= this.size) {
        return this.numberOfEntries;
      } else if (this.numberOfEntries > this.size && this.pageNumber + 1 == 1) {
        return this.size;
      } else if (this.numberOfEntries > this.size && this.pageNumber + 1 > 1) {
        if (this.numberOfEntries - this.size * (this.pageNumber + 1) > 0) {
          return this.size * (this.pageNumber + 1);
        } else {
          return this.numberOfEntries;
        }
      } else {
        return NaN;
      }
    },

    paginatedData() {
      const start = this.pageNumber * this.size,
        end = start + this.size;
      var sorted = [...this.getSuppliers];

      if (this.sortBy == "Name") {
        sorted.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase()
            ? 1
            : b.name.toLowerCase() > a.name.toLowerCase()
            ? -1
            : 0
        );
      } else {
        sorted.sort((a, b) =>
          a.serviceTypesString.toLowerCase() >
          b.serviceTypesString.toLowerCase()
            ? 1
            : b.serviceTypesString.toLowerCase() >
              a.serviceTypesString.toLowerCase()
            ? -1
            : 0
        );
        console.log(sorted);
      }
      return sorted.slice(start, end);
    },
  },
  methods: {
    showSearch() {
      this.visibleSearch = !this.visibleSearch;
    },
    clickCallback(pageNum) {
      this.pageNumber = pageNum - 1;
    },
    fetchStatement: function () {
      this.mute = true;
      //this.buildingId = 3;
      var request = "/suppliers/building?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.suppliers = data;
        });
    },
    editItem: function (item) {
      this.$router.push({
        name: "supplier",
        params: {
          id: item.id,
          buildingId: this.buildingId,
          buildingName: this.buildingName,
        },
      });
    },
    modalClosed: function (itemDeleted) {
      if (itemDeleted) this.fetchStatement();
    },
    deleteItem: function destroy(item) {
      this.selectedItemId = item.id;
      this.deleteAlert();
    },
    deleteAlert: function () {
      this.$modal.show("deleteAlert");
    },
  },
};
</script>